(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('home-carousel')) {
    class HomeCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.home-hero__track');
        this.slides = [...this.querySelectorAll('.home-hero__slide')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.index = 0;
        if (this.slides.length < 2) return;

        this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.dot), true)));

        this.observer = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
                this.setActive(Number(entry.target.dataset.index));
              }
            }
          },
          { root: this.track, threshold: [0.6] }
        );
        this.slides.forEach((slide) => this.observer.observe(slide));

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !reduceMotion && !window.Shopify?.designMode;
        this.interval = Number(this.dataset.interval) || 6000;
        this.paused = false;

        for (const event of ['mouseenter', 'focusin', 'touchstart']) {
          this.addEventListener(event, () => (this.paused = true), { passive: true });
        }
        this.addEventListener('mouseleave', () => (this.paused = false));
        this.addEventListener('focusout', (e) => {
          if (!this.contains(e.relatedTarget)) this.paused = false;
        });

        if (this.autoplay) this.start();

        document.addEventListener('shopify:block:select', (e) => {
          const i = this.slides.findIndex((slide) => slide.contains(e.target) || slide === e.target);
          if (i > -1) this.go(i, true);
        });
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        this.observer?.disconnect();
      }

      start() {
        clearInterval(this.timer);
        this.timer = setInterval(() => {
          if (!this.paused && !document.hidden) this.go(this.index + 1);
        }, this.interval);
      }

      go(i, fromUser = false) {
        const count = this.slides.length;
        const next = (i + count) % count;
        this.track.scrollTo({ left: this.slides[next].offsetLeft, behavior: 'smooth' });
        this.setActive(next);
        if (fromUser && this.autoplay) this.start();
      }

      setActive(i) {
        this.index = i;
        this.dots.forEach((dot, n) => dot.setAttribute('aria-current', n === i ? 'true' : 'false'));
      }
    }

    customElements.define('home-carousel', HomeCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-signup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('klaviyo-signup')) {
    const KLAVIYO_REVISION = '2026-07-15';
    const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    class KlaviyoSignup extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[type="email"]');
        this.button = this.querySelector('button[type="submit"]');
        this.status = this.querySelector('.newsletter__status');
        this.form?.addEventListener('submit', (event) => this.onSubmit(event));
      }

      setStatus(message, state) {
        this.status.textContent = message;
        this.status.dataset.state = state;
      }

      async onSubmit(event) {
        event.preventDefault();

        const email = this.input.value.trim();
        const honeypot = this.form.elements.company?.value;
        const { companyId, listId, source } = this.dataset;

        if (honeypot) return;

        if (!EMAIL_PATTERN.test(email)) {
          this.setStatus('Enter a valid email address, like name@example.com.', 'error');
          this.input.focus();
          return;
        }

        if (!companyId || !listId) {
          this.setStatus('Signup isn’t set up yet. Add the Klaviyo site ID and list ID in this section’s settings.', 'error');
          return;
        }

        this.button.disabled = true;
        this.setStatus('Signing you up…', 'pending');

        try {
          const response = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(companyId)}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/vnd.api+json',
              Accept: 'application/vnd.api+json',
              revision: KLAVIYO_REVISION,
            },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: source || 'Blog signup',
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: {
                        email,
                        subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                      },
                    },
                  },
                },
                relationships: { list: { data: { type: 'list', id: listId } } },
              },
            }),
          });

          if (!response.ok) {
            const detail = await response.json().catch(() => null);
            throw new Error(detail?.errors?.[0]?.detail || `Klaviyo responded ${response.status}`);
          }

          this.setAttribute('data-done', '');
          this.setStatus(this.status.dataset.success || 'You’re subscribed. Welcome!', 'success');
          window.dispatchEvent(new CustomEvent('newsletter:subscribed', { detail: { source } }));
        } catch (error) {
          console.warn('[newsletter] Klaviyo signup failed.', error);
          this.button.disabled = false;
          this.setStatus('That didn’t go through. Check your email address and try again.', 'error');
        }
      }
    }

    customElements.define('klaviyo-signup', KlaviyoSignup);
  }

  } catch(e) { console.error(e); }
})();
})();
